export default __webpack_public_path__ + "static/media/start-time.0b075d7d.svg";